module.exports = __webpack_public_path__ + "img/beneficiary-link.d1f47d33.svg";